import { Keyword, Token, Tuple } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
import { Longhand } from "../longhand.js";
const { delimited, map, option, takeBetween } = Parser;
/**
 * @internal
 */
export const parse = map(takeBetween(delimited(option(Token.parseWhitespace), Keyword.parse("stretch", "repeat", "round", "space")), 1, 2), ([vertical, horizontal = vertical]) => Tuple.of(vertical, horizontal));
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/border-image-repeat}
 * @internal
 */
export default Longhand.of(Tuple.of(Keyword.of("stretch"), Keyword.of("stretch")), parse, (value) => value);
//# sourceMappingURL=border-image-repeat.js.map